import React, { Component } from 'react'
import { PageHeader, Button, Descriptions, Form, message } from 'antd'
import { Select } from 'antd';
import { Table, Modal, Card, Row, Col, Spin } from 'antd';
import {
    getTagList,
    getTagCount,
    getTagContent,
    getTagDelIns,
    getTagFinish,
    takeoffAll,
    inspiration_Searchword_batchHandleTag
} from "../../../api/inspiration";

const { Option } = Select;

var addEvent = (function () {
    if (window.addEventListener) {
        return function (elm, type, handle) {
            elm.addEventListener(type, handle, false);
        }
    }
    if (window.attachEvent) {
        return function (elm, type, handle) {
            elm.attachEvent('on' + type, handle);
        }
    }
})();

class Index extends Component {

    constructor(props) {
        super(props);
        message.config({
            maxCount: 2,
        });
        this.columns = [
            {
                title: '序号',
                dataIndex: 'tagReviewId',
                render: (text, record, index) => {
                    return text
                }
            },
            {
                title: '标签',
                dataIndex: 'word',
                render: (text, record, index) => {
                    return text
                }
            },
            {
                title: '原始图片量',
                dataIndex: 'originalCount',
                sorter: true,
            },
            {
                title: '剩余图片量',
                dataIndex: 'currentCount',
                sorter: true,
            },
            {
                title: '操作',
                dataIndex: 'operation',
                render: (text, record, index) => {
                    return (
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <Button type="primary"
                                onClick={() => this.setModalData(record.tagReviewId, record.word.trim(), index)}>
                                查看
                            </Button>
                            <Button type="danger" style={{ marginLeft: 20 }}
                                onClick={() => this.goTakeOffAll(record.tagReviewId)}>
                                全部下架
                            </Button>
                        </div>
                    )
                }
            },
        ];
        this.state = {
            columns: [],
            data: [],
            pagination: {},
            loading: false,
            modal2Visible: false,
            unHandledCount: 0,
            passCount: 0,
            refuseCount: 0,
            selectedStatus: 0,
            content: [],
            selectedSearchWordId: null,
            selectedSearchWord: '',
            selectedContentIndex: 0,
            reviewedCount: 0,
            unReviewCount: 0,
            modalPage: 1,
            modalPageSize: 100
        };

    }

    componentDidMount() {
        if (window.location.search.includes('page=')) {
            let page = window.location.search.split('page=')[1]
            this.initSearchWordCount();
            this.fetch({ page });
        } else {
            this.initSearchWordCount();
            this.fetch();
        }
    }

    /**
     * 初始化搜索词数量
     * @returns {Promise<void>}
     */
    initSearchWordCount = async () => {
        await getTagCount().then((res) => {
            if (res.error.code === 0) {
                this.setState({
                    reviewedCount: res.data.reviewedCount,
                    unReviewCount: res.data.unReviewCount,
                })
            }
        })
    };

    goTakeOffAll = async (tagReviewId) => {
        const { sortField, sortOrder, pagination } = this.state
        await takeoffAll(tagReviewId)
        this.fetch({
            results: pagination.pageSize,
            page: pagination.current,
            sortField: sortField,
            sortOrder: sortOrder,
        })
    }

    /**
     * 切换弹窗显示状态
     * @param modal2Visible
     */
    setModal2Visible = async (modal2Visible) => {
        this.setState({ modal2Visible });
    };

    setModalData = async (tagReviewId, word, index) => {
        message.loading('加载中...', 0);
        await getTagContent({ tagReviewId, page: 1, pageSize: this.state.modalPageSize }).then((res) => {
            if (res.error.code === 0) {
                this.setState({
                    content: res.data,
                    selectedSearchWordId: tagReviewId,
                    selectedSearchWord: word,
                    selectedContentIndex: index,
                    modalPage: 2
                })
            }
            console.log(this.state.selectedContentIndex)
        }).finally(() => {
            this.setState({ modal2Visible: true });
            message.destroy();
            setTimeout(() => {
                var div = document.querySelector('.ant-modal-body');
                addEvent(div, 'scroll', async () => {
                    var scrollHeight = div.scrollHeight;
                    var scrollTop = div.scrollTop;
                    var height = div.offsetHeight;
                    console.log(scrollHeight, scrollTop, height)
                    if ((scrollTop + height) >= scrollHeight) {
                        console.log('到底了');
                        message.loading('加载中')
                        const content = await getTagContent({ tagReviewId, page: this.state.modalPage, pageSize: this.state.modalPageSize })
                        console.log('content', content)
                        if (content.data.length) {
                            this.setState({
                                content: [...this.state.content, ...content.data],
                                modalPage: this.state.modalPage + 1
                            })
                        } else {
                            message.info('没有数据了')
                        }
                    }
                });
            }, 500)
        });
    };

    /**
     * 处理表格变换行为
     * @param pagination
     * @param filters
     * @param sorter
     */
    handleTableChange = async (pagination, filters, sorter) => {
        const pager = { ...this.state.pagination };
        pager.current = pagination.current;
        await this.setState({
            pagination: pager,
        });

        let sortOrder;
        if (sorter.order) {
            if (sorter.order.indexOf('asc') > -1) {
                sortOrder = 'asc'
            } else {
                sortOrder = 'desc'
            }
        } else {
            sortOrder = null
        }

        this.setState({
            sortField: sorter.field,
            sortOrder: sortOrder,
        })

        this.fetch({
            results: pagination.pageSize,
            page: pagination.current,
            sortField: sorter.field,
            sortOrder: sortOrder,
        });
    };

    /**
     * 请求列表数据
     * @param params
     * @returns {Promise<void>}
     */
    fetch = async (params = {}) => {
        console.log('params', params)
        this.setState({ loading: true });
        await getTagList({ page: params.page ? params.page : 1, status: this.state.selectedStatus, column: params.sortField ? params.sortField : '', sort: params.sortOrder ? params.sortOrder : '' }).then((result) => {
            if (result.error.code === 0) {
                const pagination = { ...this.state.pagination };
                pagination.total = parseInt(result.data.totalElements);
                pagination.pageSize = 50
                if (params.page) {
                    pagination.current = parseInt(params.page)
                }
                this.setState({
                    data: result.data.content,
                    pagination,
                });
            }
        }).finally(() => {
            this.setState({
                loading: false,
            })
        });

    };

    /**
     * 下拉选择框改变时的处理
     * @param value
     */
    handleChange = async (value) => {
        await this.setState({
            selectedStatus: value
        });
        this.fetch()
    };

    /**
     * 点击单张图片->不通过
     */
    nopassSingleIns = async (insId, index) => {
        const { selectedSearchWord } = this.state
        let data = this.state.content;
        if (data[index].dis !== true) {
            const res = await getTagDelIns({ word: selectedSearchWord, insId })
            console.log(res)
            data[index].dis = true;
            this.setState({
                content: data
            });
        }
    };

    /**
     * 选中通过
     */
    chooseAll = async () => {
        let content = this.state.content;
        let passList = [];
        let noPassList = []
        for (let i = 0; i < content.length; i++) {
            let item = content[i];
            if (item.dis == true) {
                passList.push(item.insId)
            } else {
                noPassList.push(item.insId)
            }
        }
        let param = {
            passList: passList,
            noPassList: noPassList,
            searchWordId: this.state.selectedSearchWordId,
        };
        await inspiration_Searchword_batchHandleTag(param).then((res) => {
            if (res.error.code === 0) {
                let wordData = this.state.data;
                wordData[this.state.selectedContentIndex] && (wordData[this.state.selectedContentIndex].status = 0);
                this.setState({
                    data: wordData
                });
                message.success('操作成功', 3)
            } else {
                message.error(res.error.message, 0)
            }
        }).finally(() => {
            this.setState({ modal2Visible: false });
            const selectedContentIndex = this.state.selectedContentIndex;
            const nextIndex = selectedContentIndex + 1;
            if (nextIndex >= this.state.data.length) {
                message.warning('本页搜索词已自动检索到最后一个,没有更多了!')
            } else {
                const nextData = this.state.data[nextIndex];
                this.setModalData(nextData.tagReviewId, nextData.searchWord, nextIndex)
            }
            this.initSearchWordCount()
        });
        const { pagination: { current }, sortField, sortOrder } = this.state
        this.fetch({ page: current, sortField, sortOrder })
    };

    /**
     * 未选中通过
     */
    notChooseAll = async () => {
        const { selectedSearchWordId } = this.state
        await getTagFinish(selectedSearchWordId).then((res) => {
            if (res.error.code === 0) {
                let wordData = this.state.data;
                wordData[this.state.selectedContentIndex] && (wordData[this.state.selectedContentIndex].status = 0);
                this.setState({
                    data: wordData
                });
                message.success('操作成功', 3)
            } else {
                message.error(res.error.message, 0)
            }
        }).finally(() => {
            this.setState({ modal2Visible: false });
            const selectedContentIndex = this.state.selectedContentIndex;
            const nextIndex = selectedContentIndex + 1;
            if (nextIndex >= this.state.data.length) {
                message.warning('本页搜索词已自动检索到最后一个,没有更多了!')
            } else {
                const nextData = this.state.data[nextIndex];
                this.setModalData(nextData.tagReviewId, nextData.word, nextIndex)
            }
            this.initSearchWordCount()
        });
        const { pagination: { current }, sortField, sortOrder } = this.state
        this.fetch({ page: current, sortField, sortOrder })
    };

    render() {
        const columns = this.columns;
        return <div>
            <div style={{ backgroundColor: '#F5F5F5', padding: 24, }}>
                <PageHeader
                    ghost={false}
                    title="标签管理"
                    extra={[
                        <div key={'Select'}>
                            <Select style={{ width: 120 }} onChange={this.handleChange} defaultValue={0}>
                                <Option value={0}>待审核</Option>
                                <Option value={1}>已审核</Option>
                            </Select>
                        </div>,
                    ]}
                >
                    <Descriptions size="small" column={3}>
                        <Descriptions.Item label="待审核">
                            <a>{this.state.unReviewCount}</a>
                        </Descriptions.Item>
                        <Descriptions.Item label="已审核">
                            <a>{this.state.reviewedCount}</a>
                        </Descriptions.Item>
                    </Descriptions>
                </PageHeader>
            </div>
            <div>
                <Table columns={columns}
                    rowKey={record => record.tagReviewId}
                    dataSource={this.state.data}
                    pagination={this.state.pagination}
                    loading={this.state.loading}
                    onChange={this.handleTableChange}
                />
            </div>
            <Modal
                title={<div style={{ textAlign: "center" }}>
                    {(this.state.selectedSearchWord.length <= 8) ? this.state.selectedSearchWord : this.state.selectedSearchWord.substr(0, 8) + '...'}
                </div>}
                centered
                visible={this.state.modal2Visible}
                // onOk={() => this.dealAll(false, 0)}
                // okText={'全部通过'}
                onCancel={() => {
                    var div = document.querySelector('.ant-modal-body');
                    div.removeEventListener('scroll', () => { }, false)
                    this.setState({ modalPage: 1 })
                    this.setModal2Visible(false)
                }}
                cancelText={'全部不通过'}
                footer={
                    this.state.selectedStatus == 0 ?
                        [
                            <Button type={"primary"} key={'passAll'} onClick={() => this.notChooseAll()}>审核结束</Button>
                        ]
                        :
                        null
                }
                width={1600}
                bodyStyle={{ height: 800, overflow: "auto" }}
                destroyOnClose={true}
            >
                <Row gutter={[{ xs: 8, sm: 16, md: 24, lg: 32 }, 16]} id="modal">
                    {this.state.content.map((item, index) => {
                        return <Col className="gutter-row" span={4} key={'modal.row.col.' + item.insId}>
                            <div className="gutter-box" onClick={() => this.nopassSingleIns(item.insId, index)}>
                                <Spin spinning={item.dis ? true : false} indicator={item.dis ? <div></div> : null}>
                                    <Card key={'modal.row.col.' + item.insId + '.card.' + item.insId}
                                        hoverable={true}
                                        style={{ width: 240 }}
                                        cover={<img src={item.cover} />}
                                        type={"inner"}
                                        bodyStyle={{ display: "none" }}
                                        loading={true}
                                    >
                                    </Card>
                                </Spin>
                            </div>
                        </Col>
                    })}
                </Row>
            </Modal>
        </div>
    }
}

const WrappedApp = Form.create({})(Index);

export default WrappedApp
